import * as React from 'react';

import { Stack, Typography } from '@mui/material';

import { ShiftIcon } from '../index';

export function ShiftIconTitle({ value }: { value?: string | null }) {
  return (
    <Stack
      display={'inline-flex'}
      direction="row"
      alignItems="start"
      spacing={2}
    >
      <ShiftIcon name={value} customSizes={{ width: 19, height: 19 }} />
      <Typography variant={'body2'} style={{ textTransform: 'capitalize' }}>
        {value}
      </Typography>
    </Stack>
  );
}
